const escapeHtmlAttr = (value) => value
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/</g, '&lt;');
const getOriginFromUrl = (url) => {
    try {
        return new URL(url).origin;
    }
    catch {
        return null;
    }
};
/** Preload-Link für das LCP-Logo (inkl. fetchpriority für Lighthouse). */
export const buildLogoPreloadLink = (logoUrl) => `<link rel="preload" as="image" href="${escapeHtmlAttr(logoUrl)}" fetchpriority="high">`;
/** Preconnect zum CDN-Origin des Logos, falls extern. */
export const buildLogoOriginPreconnectLink = (logoUrl) => {
    const origin = getOriginFromUrl(logoUrl);
    if (!origin)
        return null;
    return `<link rel="preconnect" href="${escapeHtmlAttr(origin)}" crossorigin>`;
};
/**
 * Stellt zur Laufzeit sicher, dass Logo-Preload und Preconnect im <head> stehen.
 * Aktualisiert bestehende Preloads ohne fetchpriority.
 */
export const ensureLogoLcpHints = (logoUrl) => {
    if (typeof document === 'undefined')
        return;
    const trimmed = logoUrl?.trim();
    if (!trimmed)
        return;
    const existingPreload = document.querySelector(`link[rel="preload"][as="image"][href="${CSS.escape(trimmed)}"]`);
    if (existingPreload) {
        if (!existingPreload.getAttribute('fetchpriority')) {
            existingPreload.setAttribute('fetchpriority', 'high');
        }
    }
    else {
        const preload = document.createElement('link');
        preload.rel = 'preload';
        preload.as = 'image';
        preload.href = trimmed;
        preload.setAttribute('fetchpriority', 'high');
        document.head.appendChild(preload);
    }
    const origin = getOriginFromUrl(trimmed);
    if (!origin || origin === window.location.origin)
        return;
    const existingPreconnect = document.querySelector(`link[rel="preconnect"][href="${CSS.escape(origin)}"]`);
    if (!existingPreconnect) {
        const preconnect = document.createElement('link');
        preconnect.rel = 'preconnect';
        preconnect.href = origin;
        preconnect.crossOrigin = '';
        document.head.appendChild(preconnect);
    }
};
